/* eslint-disable */
import { useEffect, useRef } from 'react';
import { Dialog, DialogContent, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import { MemoryRouter, Route, Switch, useHistory, useLocation } from 'react-router-dom';
import ProductCreatePage from '@/Pages/Food Products/All Products/ProductCreatePage';
import { urls } from '@/Constants';

const INITIAL_ROUTE = `${urls.EXTENSION}${urls.ALL_PRODUCTS}/add`;
const LIST_ROUTE = `${urls.EXTENSION}${urls.ALL_PRODUCTS}`;

const PageBodyWithCloseOnSave = ({ onSaved, onCancelled }) => {
	const history = useHistory();
	const location = useLocation();
	const initialKeyRef = useRef(history?.location?.key);

	useEffect(() => {
		if (history?.location?.key === initialKeyRef.current) return;
		const path = location?.pathname || '';
		if (path === LIST_ROUTE || path.endsWith(urls.ALL_PRODUCTS)) {
			onSaved?.();
		}
	}, [location, history, onSaved]);
	return (
		<div
			className='App-root'
			style={{
				display: 'block',
				width: '100%',
				minHeight: 'auto',
				height: 'auto',
			}}
		>
			<Switch>
				<Route path='*'>
					<ProductCreatePage breadcrumbs={[]} />
				</Route>
			</Switch>
		</div>
	);
};

const QuickProductCreateModal = ({
	open,
	initialName = '',
	onClose,
	onSaved,
}) => {
	return (
		<Dialog
			open={open}
			onClose={(_, reason) => {
				if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
				onClose?.();
			}}
			fullWidth
			maxWidth={false}
			PaperProps={{
				sx: {
					width: '95vw',
					maxWidth: '95vw',
					height: '90vh',
					position: 'relative',
					overflow: 'hidden',
					display: 'flex',
					flexDirection: 'column',
					m: 0,
				},
			}}
		>
			{initialName && (
				<div
					style={{
						position: 'absolute',
						top: 6,
						left: '50%',
						transform: 'translateX(-50%)',
						zIndex: 13,
						pointerEvents: 'none',
					}}
					className='flex items-center gap-2 px-2.5 py-1 rounded-md bg-amber-100/95 border border-amber-300 shadow-sm'
				>
					<span className='text-[11px] text-slate-700'>
						Suggested name from your paste:{' '}
						<span className='font-semibold text-slate-900'>
							&ldquo;{initialName}&rdquo;
						</span>
					</span>
				</div>
			)}
			<IconButton
				onClick={() => onClose?.()}
				size='small'
				sx={{
					position: 'absolute',
					top: 6,
					right: 28,
					zIndex: 14,
					bgcolor: 'white',
					boxShadow: 1,
					borderRadius: '4px',
					p: '4px',
					'&:hover': { bgcolor: 'grey.100' },
				}}
			>
				<Close fontSize='small' className='text-slate-600' />
			</IconButton>
			<DialogContent
				dividers={false}
				sx={{ p: 0, flex: 1, overflow: 'auto', bgcolor: 'white' }}
			>
				{open && (
					<MemoryRouter initialEntries={[INITIAL_ROUTE]}>
						<PageBodyWithCloseOnSave
							onSaved={() => {
								onSaved?.();
								onClose?.();
							}}
							onCancelled={() => onClose?.()}
						/>
					</MemoryRouter>
				)}
			</DialogContent>
		</Dialog>
	);
};

export default QuickProductCreateModal;
